import { Timer } from 'lucide-react';
import { useCallback, useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { useCreateRecruitmentContext } from '../../../../../Create/Contexts/CreateRecruitmentContext';
import type { SelectTestsFormValues } from '../../../SelectTestsStep.schema';
import { TestTypes } from '@/Models/Configuration';
import UIStrings from '@/Utils/UIStrings';

function EstimatedTime() {
    const { testInfos } = useCreateRecruitmentContext();
    const { isAptitudeSelected, isEmotionalIntelligenceSelected, isPersonalitySelected, isSkillsSelected } =
        useWatch<SelectTestsFormValues>();

    const getTestDuration = useCallback((t: TestTypes, isSelected?: boolean) => {
        let duration = 0;
        if (isSelected) {
            const test = testInfos.find(({ testType }) => t === testType);
            if (test) {
                duration = test.duration;
            }
        }

        return duration;
    }, []);

    const aptitudeDuration = useMemo(
        () => getTestDuration(TestTypes.Aptitude, isAptitudeSelected),
        [getTestDuration, isAptitudeSelected],
    );
    const emotionalIntelligenceDuration = useMemo(
        () => getTestDuration(TestTypes.EmotionalIntelligence, isEmotionalIntelligenceSelected),
        [getTestDuration, isEmotionalIntelligenceSelected],
    );
    const personalityDuration = useMemo(
        () => getTestDuration(TestTypes.Personality, isPersonalitySelected),
        [getTestDuration, isPersonalitySelected],
    );
    const skillsDuration = useMemo(
        () => getTestDuration(TestTypes.Skills, isSkillsSelected),
        [getTestDuration, isSkillsSelected],
    );
    const estimatedDuration = aptitudeDuration + emotionalIntelligenceDuration + personalityDuration + skillsDuration;

    return (
        <div className="text-foreground flex flex-row items-center justify-center gap-2 text-sm">
            <Timer className="mb-1 size-6 shrink-0" aria-hidden />
            <span>{`${UIStrings.EstimatedTotalAdministrationTime}:`}</span>
            <span data-cy={UIStrings.Minutes} className="text-primary font-medium">
                {estimatedDuration}
            </span>
            <span className="font-semibold">{UIStrings.Minutes}</span>
        </div>
    );
}

export default EstimatedTime;
